// import React from "react";

// export default function Card({
//   header,
//   body,
//   label,
//   headerValue,
//   rightButtonLabel,
//   rightButtonHandler,
// }) {
//   return (
//     <div className="w-100">
//       <div className="d-flex w-100 justify-content-between align-items-center pt-3 mb-3">
//         {label ? (
//           <p className="text-primary m-0 fw-semibold">
//             {label}
//             {headerValue ? (
//               <span className="text-danger ps-1">({headerValue})</span>
//             ) : null}
//           </p>
//         ) : null}
//         {rightButtonLabel && rightButtonHandler ? (
//           <button
//             onClick={rightButtonHandler}
//             className="btn btn-link fw-medium"
//             style={{ fontSize: ".875rem" }}
//           >
//             {rightButtonLabel}
//           </button>
//         ) : null}
//       </div>
//       <div className="col w-100">
//         <div className="row bg-primary text-center pt-3 pb-3 rounded-top">
//           {header.map((item) => {
//             return (
//               <div key={item} className="col text-white fw-semibold">
//                 <p className="m-0 p-0" style={{ fontSize: ".9rem" }}>
//                   {item}
//                 </p>
//               </div>
//             );
//           })}
//         </div>
//         {body.map((item, index) => {
//           return (
//             <div
//               className={`row text-center pt-3 pb-3 ${
//                 body.length - 1 === index ? "rounded-bottom" : ""
//               }`}
//               style={{
//                 background: "white",
//                 borderBottom: "1px solid rgba(0, 0, 0, .1)",
//               }}
//             >
//               {item.map((data) => {
//                 return (
//                   <div key={item} className="col">
//                     <p className="m-0 p-0" style={{ fontSize: ".9rem" }}>
//                       {data}
//                     </p>
//                   </div>
//                 );
//               })}
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }

import React from "react";

export default function Card({
  header,
  body,
  label,
  headerValue,
  rightButtonLabel,
  rightButtonHandler,
}) {
  return (
    <div className="w-100">
      <div className="d-flex w-100 justify-content-between align-items-center pt-3 mb-3">
        {label ? (
          <p className="text-primary m-0 fw-semibold">
            {label}
            {headerValue ? (
              <span className="text-danger ps-1">({headerValue})</span>
            ) : null}
          </p>
        ) : null}
        {rightButtonLabel && rightButtonHandler ? (
          <button
            onClick={rightButtonHandler}
            className="btn btn-link fw-medium"
            style={{ fontSize: ".875rem" }}
          >
            {rightButtonLabel}
          </button>
        ) : null}
      </div>
      <div className="col w-100">
        <div className="row bg-primary text-center pt-3 pb-3 rounded-top">
          {header.map((item) => (
            <div key={item} className="col text-white fw-semibold">
              <p className="m-0 p-0" style={{ fontSize: ".9rem" }}>
                {item}
              </p>
            </div>
          ))}
        </div>

        {body.length === 0 ? (
          <div
            className="row text-center pt-3 pb-3 rounded-bottom"
            style={{
              background: "white",
              borderBottom: "1px solid rgba(0, 0, 0, .1)",
            }}
          >
            <div className="col mt-4">
              <p className="m-0 p-0" style={{ fontSize: ".9rem" }}>
                CourtCase Not Found
              </p>
            </div>
          </div>
        ) : (
          body.map((item, index) => (
            <div
              key={index}
              className={`row text-center pt-3 pb-3 ${
                body.length - 1 === index ? "rounded-bottom" : ""
              }`}
              style={{
                background: "white",
                borderBottom: "1px solid rgba(0, 0, 0, .1)",
              }}
            >
              {item.map((data, idx) => (
                <div key={idx} className="col">
                  <p className="m-0 p-0" style={{ fontSize: ".9rem" }}>
                    {data}
                  </p>
                </div>
              ))}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
